<template>
	<div id="app" v-touch:right="onSwipeLeft">
		<div ref="bottomInsetProbe" class="bottom-inset-probe" aria-hidden="true"></div>
		<router-view />
		<site-menu-trigger v-if="showCompactMenuTrigger" class="site-menu-trigger--floating" compact />
		<button v-if="showNoticeFloat" type="button" class="kefu notice-float" :class="{ 'has-unread': unread > 0 }" :aria-label="$t('notice.message')" @click="$router.push('/notice')">
			<van-icon name="comment-circle" size="30" color="#ffcf26" />
			<span v-if="unread > 0" class="msg-count">{{ unread > 99 ? '99+' : unread }}</span>
		</button>
		       <!-- <div class="download_box" v-if="is_show_footer && app.is_disable === 'Y' && is_show_down_app">
            <a :href="app.app_link" class="down">
                <div class="down_left">
                    <span class="app_logo" v-bind:style="{'background-image':'url(' + app.image + ')'}"></span>
                    <div class="app_info">
                        {{app.text1}}<br>{{app.text2}}
                    </div>
                </div>
                <div class="right">App客户端</div>
            </a>
            <span class="close_down" @click="closeDownApp"></span>
        </div> -->
		<van-popup
			v-model:show="sideNavigationOpen"
			class="site-navigation-drawer"
			position="left"
			teleport="body"
			:close-on-click-overlay="true"
		>
			<aside class="site-navigation-drawer__content" role="dialog" aria-modal="true" :aria-label="siteTitle">
				<h2 class="site-navigation-drawer__title">{{ siteTitle }}</h2>
				<nav class="site-navigation-drawer__list" :aria-label="$t('index.more')">
					<button
						v-for="item in navigationItems"
						:key="item.type"
						type="button"
						class="site-navigation-drawer__item"
						:class="{ 'is-active': isNavigationItemActive(item) }"
						@click="navigateFromDrawer(item)"
					>
						<img class="site-navigation-drawer__icon" :src="isNavigationItemActive(item) ? item.activeIcon : item.icon" alt="" />
						<span>{{ $t(item.label) }}</span>
						<img class="site-navigation-drawer__arrow" :src="isNavigationItemActive(item) ? drawerArrowActive : drawerArrow" alt="" />
					</button>
				</nav>
			</aside>
		</van-popup>
		<div v-show="real_name" class="real_name_mask">
			<div class="real_box">
				<div class="tit" />
				<p class="tips">
					{{$t('index.moneyset')}}
				</p>
				<div class="basic_btn" @click="real_name = false">
					{{$t('index.setnow')}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import footerHome from './assets/images/help/tab-home.png';
	import footerHomeActive from './assets/images/help/tab-home-active.png';
	import footerHelp from './assets/images/help/tab-help.png';
	import footerHelpActive from './assets/images/help/tab-help-active.png';
	import footerNotice from './assets/images/help/tab-notice.png';
	import footerNoticeActive from './assets/images/help/tab-notice-active.png';
	import footerUser from './assets/images/help/tab-user.png';
	import footerUserActive from './assets/images/help/tab-user-active.png';
	import drawerArrow from './views/images/common/right.png';
	import drawerArrowActive from './views/images/common/rightc.png';
	import SiteMenuTrigger from './components/SiteMenuTrigger.vue';

	import Fetch from "./utils/fetch";
	import { isLoggedIn } from './utils/wallet/auth';

	export default {
		name: 'App',
		components: {
			SiteMenuTrigger,
		},
		provide() {
			return {
				footer: this.footer,
				siteNavigation: this.navigationContext,
			};
		},
		data() {
			return {
				show_icon_type: 'index',
				real_name: false,
				is_show_down_app: true,
				is_show_footer: true,
			footerIcons: {
				home: footerHome,
					homeActive: footerHomeActive,
					help: footerHelp,
					helpActive: footerHelpActive,
					notice: footerNotice,
					noticeActive: footerNoticeActive,
				user: footerUser,
				userActive: footerUserActive,
			},
			drawerArrow,
			drawerArrowActive,
			unread: 0,
				unreadTimer: null,
				unreadRequestPending: false,
				unreadRefreshQueued: false,
				bottomInsetFrame: null,
				sideNavigationOpen: false,
				navigationContext: {
					title: typeof document !== 'undefined' && document.title ? document.title : 'DEFI',
					open: null,
				},
				app: {}
			}
		},
		computed: {
			showNoticeFloat() {
				return ['index', 'help', 'user'].includes(this.$route.name);
			},
			showCompactMenuTrigger() {
				return this.is_show_footer && !['index', 'help', 'notice', 'user', 'superMember', 'home', 'trading', 'vip', 'aboutus'].includes(this.$route.name);
			},
			siteTitle() {
				return this.navigationContext.title || 'DEFI';
			},
			navigationItems() {
				return [
					{ type: 'index', to: '/index', label: 'home.index', icon: this.footerIcons.home, activeIcon: this.footerIcons.homeActive },
					{ type: 'help', to: '/help', label: 'helpPage.navHelp', icon: this.footerIcons.help, activeIcon: this.footerIcons.helpActive },
					{ type: 'notice', to: '/notice', label: 'helpPage.navNotice', icon: this.footerIcons.notice, activeIcon: this.footerIcons.noticeActive },
					{ type: 'user', to: '/user', label: 'home.my', icon: this.footerIcons.user, activeIcon: this.footerIcons.userActive },
				];
			}
		},
		watch: {
			'$route.name'() {
				this.updateUnreadSync();
			}
		},
		updated() {
			document.body.scrollTop = 0
			document.documentElement.scrollTop = 0
		},
		created() {
			this.navigationContext.open = () => this.openSideNavigation();
		},
		mounted() {
			this.start();
			this.updateUnreadSync();
			this.addBottomInsetListeners();
			this.updateBottomInset();
			window.addEventListener('trustwallet#initialized', this.updateBottomInset);
			window.addEventListener('ethereum#initialized', this.updateBottomInset);
			window.addEventListener('notice-read', this.requestUnreadRefresh);
		},
		beforeUnmount() {
			this.stopUnreadSync();
			this.removeBottomInsetListeners();
			window.removeEventListener('trustwallet#initialized', this.updateBottomInset);
			window.removeEventListener('ethereum#initialized', this.updateBottomInset);
			window.removeEventListener('notice-read', this.requestUnreadRefresh);
		},
		// setup() {
		// 	const footer = (type = 'index', show_footer = true) => {
		// 	const appElement = document.getElementById('app');
		// 	  if (type === 'walfare') {
		// 		appElement.style.paddingBottom = '0';
		// 	  } else {
		// 		appElement.style.paddingBottom = '1.333333rem';
		// 	  }
		// 	  this.show_icon_type = type;
		// 	  this.is_show_footer = show_footer;
		// 	};
		// 	provide('footer', footer);
		// },
		methods: {
			openSideNavigation() {
				this.sideNavigationOpen = true;
			},
			isNavigationItemActive(item) {
				return this.show_icon_type === item.type;
			},
			navigateFromDrawer(item) {
				this.sideNavigationOpen = false;
				if (this.$route.path !== item.to) this.$router.push(item.to);
			},
			onSwipeLeft (even,start,end) {
				console.log();
				if(end['X']-start['X']>60){
					this.$router.go(-1);
				}
			},
			bigNumeber(str) {
				var str = str.toString();
				var strs = str.split(".");
				var s1 = strs[0] || 0;
				var s2 = strs[1] || "00"
				return `<span class="bigNum">${s1}</span><span>.</span><span>${s2}</span>`;
			},
			numFilter(value) {
				let transformVal = parseFloat(value).toFixed(3)
				let realVal = transformVal.substring(0, transformVal.length - 1)
				return parseFloat(realVal)
			},
			footer: function(type = 'index', show_footer = true) {
				const appElement = document.getElementById('app');
				appElement.style.paddingBottom = '0';
				appElement.style.background = type == 'help' || type == 'index' || type == 'notice' ? '#000' : '#f3f3f3';
				this.show_icon_type = type;
				this.is_show_footer = show_footer;
			},
			isTrustWalletBrowser() {
				const userAgent = navigator.userAgent || '';
				if (/TrustWallet|Trust\//i.test(userAgent)) return true;

				try {
					const provider = window.ethereum;
					const trustWallet = window.trustwallet;
					if (trustWallet) return true;
					const providers = provider && Array.isArray(provider.providers) ? provider.providers : [provider];
					return providers.some((item) => item && (item.isTrust || item.isTrustWallet));
				} catch (error) {
					return false;
				}
			},
			getSafeAreaInset() {
				const probe = this.$refs.bottomInsetProbe;
				return probe ? Math.round(probe.getBoundingClientRect().height) : 0;
			},
			updateBottomInset() {
				if (this.bottomInsetFrame) return;

				this.bottomInsetFrame = window.requestAnimationFrame(() => {
					this.bottomInsetFrame = null;
					const safeAreaInset = this.getSafeAreaInset();
					const viewport = window.visualViewport;
					let viewportInset = 0;

					if (viewport) {
						const layoutHeight = Math.max(window.innerHeight || 0, document.documentElement.clientHeight || 0);
						const visibleBottom = viewport.height + viewport.offsetTop;
						viewportInset = Math.max(0, Math.round(layoutHeight - visibleBottom));
					}

					let trustWalletInset = 0;
					if (this.isTrustWalletBrowser()) {
						const screenHeight = window.screen && window.screen.height ? window.screen.height : 0;
						const availableHeight = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
						const browserInset = screenHeight ? Math.max(0, Math.round(screenHeight - availableHeight)) : 0;
						trustWalletInset = Math.max(88, browserInset);
					}
					const bottomInset = 150;//Math.min(120, Math.max(safeAreaInset, viewportInset, trustWalletInset));
					document.documentElement.style.setProperty('--wallet-browser-bottom-inset', `${bottomInset}px`);
				});
			},
			addBottomInsetListeners() {
				window.addEventListener('resize', this.updateBottomInset);
				window.addEventListener('orientationchange', this.updateBottomInset);
				if (window.visualViewport) {
					window.visualViewport.addEventListener('resize', this.updateBottomInset);
					window.visualViewport.addEventListener('scroll', this.updateBottomInset);
				}
			},
			removeBottomInsetListeners() {
				window.removeEventListener('resize', this.updateBottomInset);
				window.removeEventListener('orientationchange', this.updateBottomInset);
				if (window.visualViewport) {
					window.visualViewport.removeEventListener('resize', this.updateBottomInset);
					window.visualViewport.removeEventListener('scroll', this.updateBottomInset);
				}
				if (this.bottomInsetFrame) {
					window.cancelAnimationFrame(this.bottomInsetFrame);
					this.bottomInsetFrame = null;
				}
				document.documentElement.style.removeProperty('--wallet-browser-bottom-inset');
			},
			start() {
				Fetch("/index/webconfig", {}, { timeout: 10000, silentBusinessError: true }).then((r) => {
					if(r.data){
						this.app = r.data;
						const siteTitle = String(r.data.title || '').trim();
						if (siteTitle) {
							this.navigationContext.title = siteTitle;
							window.document.title = siteTitle;
						}
						this.$i18n.locale = r.data.lang;
						localStorage.setItem("lang", r.data.lang);
						localStorage.setItem("moneyMark", r.data.money_mark);
					}
				}).catch(() => {
					// Keep the default locale and render the site when configuration is unavailable.
				});
			},
			closeDownApp() {
				this.is_show_down_app = false;
			},
			updateUnreadSync() {
				if (!this.showNoticeFloat) {
					this.stopUnreadSync();
					this.unread = 0;
					return;
				}
				this.requestUnreadRefresh();
				if (!this.unreadTimer) {
					this.unreadTimer = window.setInterval(() => this.requestUnreadRefresh(), 30000);
				}
			},
			stopUnreadSync() {
				if (this.unreadTimer) {
					window.clearInterval(this.unreadTimer);
					this.unreadTimer = null;
				}
			},
			requestUnreadRefresh() {
				if (this.unreadRequestPending) {
					this.unreadRefreshQueued = true;
					return;
				}
				this.refreshUnread();
			},
			async refreshUnread() {
				if (!this.showNoticeFloat || this.unreadRequestPending) return;
				if (!isLoggedIn()) {
					this.unread = 0;
					return;
				}
				this.unreadRequestPending = true;
				try {
					const response = await Fetch('/index/sync', {}, { silentBusinessError: true }, false);
					if (response && response.code === 1) {
						this.unread = Number(response.data) > 0 ? Number(response.data) : 0;
					}
				} finally {
					this.unreadRequestPending = false;
					if (this.unreadRefreshQueued) {
						this.unreadRefreshQueued = false;
						this.refreshUnread();
					}
				}
			},
		}
	}
</script>
<style lang="less">
	:root {
		--wallet-browser-bottom-inset: env(safe-area-inset-bottom, 0px);
	}

	.bottom-inset-probe {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 0;
		height: 0;
		padding-bottom: env(safe-area-inset-bottom, 0px);
		visibility: hidden;
		pointer-events: none;
	}

	// @import "./assets/font/font.css";
	.kefu {
		width: 38px;
		height: 38px;
		position: fixed;
		z-index: 10;
		right: 20px;
		bottom: 25vh;
		transition: all 1s;
		opacity: 1;
		transform: translateX(0);
		z-index: 80;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.kefu.kefu_hide {
		transform: translateX(70%);
		opacity: 0.5;
	}

	.notice-float {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0;
		border: 2px solid #252525;
		border-radius: 50%;
		background: #050505;
		box-shadow: 0 3px 10px rgba(0, 0, 0, .55);
		color: #fff;
		cursor: pointer;
	}

	.notice-float.has-unread {
		border-color: #ffcf26;
		background: radial-gradient(circle, rgba(255, 207, 38, .32) 0, rgba(255, 207, 38, .08) 58%, transparent 72%);
		box-shadow: 0 0 0 4px rgba(255, 207, 38, .12), 0 0 16px rgba(255, 207, 38, .42);
		animation: notice-breathe 2.2s ease-in-out infinite;
	}

	.notice-float.has-unread::before {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 100%;
		height: 100%;
		border: 1px solid rgba(255, 207, 38, .7);
		border-radius: 50%;
		content: '';
		transform: translate(-50%, -50%);
		animation: notice-ripple 2.2s ease-out infinite;
	}

	.notice-float .msg-count {
		position: absolute;
		top: -6px;
		right: -7px;
		z-index: 2;
		min-width: 16px;
		height: 16px;
		padding: 0 3px;
		box-sizing: border-box;
		border: 2px solid #1d1d1d;
		border-radius: 10px;
		background: #ff5e57;
		color: #fff;
		font-size: 10px;
		font-weight: 700;
		line-height: 12px;
		text-align: center;
		animation: notice-count-pop .45s ease-out;
	}

	@keyframes notice-breathe {
		0%, 100% { transform: scale(1); }
		50% { transform: scale(1.07); }
	}

	@keyframes notice-ripple {
		0% { opacity: .75; transform: translate(-50%, -50%) scale(.85); }
		70%, 100% { opacity: 0; transform: translate(-50%, -50%) scale(1.45); }
	}

	@keyframes notice-count-pop {
		0% { transform: scale(.4); }
		70% { transform: scale(1.12); }
		100% { transform: scale(1); }
	}

	@media (prefers-reduced-motion: reduce) {
		.notice-float.has-unread,
		.notice-float.has-unread::before,
		.notice-float .msg-count {
			animation: none;
		}
	}

	.numberFont {
		font-family: barlow !important;
		font-size: 14px !important;
		font-weight: bold !important;
		span:nth-of-type(3) {
			font-size: 14px !important;
		}
		span:nth-of-type(4) {
			font-size: 12px !important;
		}
	}

	html,
	body {
		width: 100%;
		height: 100%;
		overflow-y: scroll;
	}

	html::-webkit-scrollbar,
	body::-webkit-scrollbar {
		width: 0px;
		height: 0px;
	}

	body {
		margin: 0;
	}

	.bigNum {
		font-size: 18px !important;
	}

	.fh {
		font-size: 12px !important;
	}

	.larfont .fh {
		margin-top: 3px;
	}

	.wan {
		font-size: 14px;
		margin-top: 2px;
	}

	.numberFontBold {
		span:first-child {
			font-size: 12px;
			margin-top: 4px;
		}

		span:last-child {
			margin-top: 2px;
		}
	}

	#app {
		padding-bottom: 50px !important;
		min-height: 100%;
		height: auto;
		width: 100%;
		max-width: 375px;
		background-color: #FAFAFA;
		max-width: 720px;
		margin: auto;
		// background-color: #00c0ff;
		// background: url(./views/images/shop2/1.png) no-repeat top;
		// background: linear-gradient(180deg, #2F8886 0%, #28475C 100%);
		background-size: 100% 100%;
		background: #000!important;
		color: #727d91;

	}
	@media screen and (min-width: 768px) {
		#app {
			width:600px !important;
		}

	}

	#app .download_box {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		position: fixed;
		margin: 0 auto;
		left: 0;
		right: 0;
		height: 45px;
		width: 100%;
		max-width: 375px;
		background: rgba(0, 0, 0, 0.5);
		bottom: 50px;
		padding: 0 3.6%;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
		z-index: 10;
	}

	#app .download_box .down {
		-webkit-box-flex: 1;
		-ms-flex: 1 1 auto;
		flex: 1 1 auto;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		padding-right: 10px;
	}

	#app .download_box .down .down_left {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
	}

	#app .download_box .down .down_left .app_logo {
		display: inline-block;
		width: 40px;
		height: 40px;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		background-image: url(./views/images/home/app_logo.svg);
		margin-right: 14px;
		;
	}

	#app .download_box .down .down_left .app_info {
		font-size: 12px;
		color: #fff;
		line-height: 1.5;
		;
	}

	#app .download_box .down .right {
		background: #D8232C;
		padding: 5px 5px;
		color: #ffffff;
		border-radius: 5px;
		font-size: 12px;
	}

	#app .download_box .close_down {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 20px;
		flex: 0 0 20px;
		height: 45px;
		;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		background-image: url(./views/images/home/close.svg);
	}

	.van-popup--bottom {
		bottom: var(--wallet-browser-bottom-inset);
		max-height: calc(100% - var(--wallet-browser-bottom-inset));
	}

	.site-menu-trigger--floating {
		position: fixed;
		top: calc(10px + env(safe-area-inset-top, 0px));
		left: 12px;
		z-index: 70;
	}

	.site-navigation-drawer.van-popup--left {
		top: 0;
		width: 70%;
		max-width: 440px;
		height: 100vh;
		min-height: 100dvh;
		margin: 0;
		overflow: hidden;
		border-radius: 0;
		background: #1b1b1b;
		color: #fff;
		transform: none;
	}

	.site-navigation-drawer.van-popup--left.van-popup-slide-left-enter-from,
	.site-navigation-drawer.van-popup--left.van-popup-slide-left-leave-active {
		transform: translate3d(-100%, 0, 0);
	}

	.site-navigation-drawer__content {
		box-sizing: border-box;
		height: 100%;
		padding: 30px 20px 20px;
		background: #1b1b1b;
	}

	.site-navigation-drawer__title {
		overflow: hidden;
		margin: 0 0 52px;
		padding: 0 8px;
		color: #ffcf26;
		font-size: 24px;
		font-weight: 700;
		line-height: 1.25;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.site-navigation-drawer__list {
		display: grid;
		gap: 18px;
	}

	.site-navigation-drawer__item {
		display: grid;
		grid-template-columns: 54px minmax(0, 1fr) 18px;
		align-items: center;
		gap: 16px;
		width: 100%;
		min-height: 58px;
		padding: 0;
		border: 0;
		background: transparent;
		color: #fff;
		font-size: 14px;
		font-weight: 600;
		line-height: 1.25;
		text-align: left;
		cursor: pointer;
	}

	.site-navigation-drawer__item.is-active {
		color: #ffcf26;
	}

	.site-navigation-drawer__icon {
		width: 40px;
		height: 40px;
		padding: 8px;
		box-sizing: border-box;
		border-radius: 14px;
		background: #423d37;
		box-shadow: inset 0 1px 0 rgba(255, 255, 255, .06), 0 4px 12px rgba(0, 0, 0, .26);
		object-fit: contain;
	}

	.site-navigation-drawer__item.is-active .site-navigation-drawer__icon {
		background: #4b443b;
		box-shadow: inset 0 0 0 1px rgba(255, 207, 38, .38), 0 4px 12px rgba(0, 0, 0, .26);
	}

	.site-navigation-drawer__arrow {
		// width: 12px;
		height:12px;
		object-fit: contain;
	}

	#app .back_left {
		position: absolute;
		top: 50%;
		left: 18px;
		display: block;
		width: 24px;
		height: 24px;
		margin: 0;
		box-sizing: border-box;
		border: 1px solid #625c54;
		border-radius: 50%;
		background-color: transparent !important;
		background-image: none !important;
		filter: none !important;
		transform: translateY(-50%);
	}

	#app .back_left::before {
		position: absolute;
		top: 7px;
		left: 8px;
		width: 6px;
		height: 6px;
		border-bottom: 2px solid #f3b171;
		border-left: 2px solid #f3b171;
		content: '';
		transform: rotate(45deg);
	}

	.market-selector-sheet.van-popup--bottom {
		top: 0;
		bottom: auto;
		max-height: calc(80% - env(safe-area-inset-top, 0px));
		padding-top: env(safe-area-inset-top, 0px);
		border-radius: 0 0 16px 16px;
	}

	.market-selector-sheet.home-selector-sheet.van-action-sheet,
	.market-selector-sheet.user-dark-sheet.van-action-sheet {
		box-shadow: 0 8px 24px rgba(0, 0, 0, .45);
	}

	.market-selector-sheet.van-popup--bottom.van-popup-slide-bottom-enter-from,
	.market-selector-sheet.van-popup--bottom.van-popup-slide-bottom-leave-active {
		transform: translate3d(0, -100%, 0);
	}

	.red_top_bg {
		max-width: 750px;
		background: #f3f3f3;
		overflow: hidden;
		background-size: 100% 100%;
		position: relative;
		width: 100%;
		height: 50px;
		color: #3fd7b2;
	}

	.top_right {
		position: absolute;
		font-size: 13px;
		line-height: 18px;
		color: #3fd7b2;
		top: 10px;
		right: 10px;
	}

	.legacy-page-header {
		position: sticky;
		top: 0;
		z-index: 20;
		display: flex;
		align-items: center;
		gap: 10px;
		height: 60px !important;
		padding: 0 16px !important;
		overflow: visible;
		border-bottom: 1px solid #292929;
		background: #1d1d1d !important;
		box-sizing: border-box;
	}

	.legacy-page-header .legacy-header-actions {
		display: flex;
		min-width: 0;
		align-items: center;
		gap: 8px;
		margin-left: auto;
	}

	.legacy-page-header .top_right {
		position: static;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 34px;
		height: 34px;
		padding: 0;
		border: 1px solid #d9cfc1;
		border-radius: 50%;
		color: #f3b171;
		line-height: 1;
		box-sizing: border-box;
	}

	.limit {
		height: 20px;
		line-height: 20px;
		border-radius: 10px;
		background: rgba(241, 34, 17, 0.08);
		color: #f12211;
		text-align: center;
		padding: 0 7px;
		border: 1px solid #f12211;
		font-size: 12px;
	}

	.gray_btn {
		height: 20px;
		align-items: center;
		background: rgba(255, 255, 255, .4) !important;
		font-size: 12px;
		text-align: center;
		color: #e5e5e5 !important;
		border-radius: 10px;
		padding: 0 9px;
	}
	.rechargebtn{
		 // background: linear-gradient(270deg,#ffd543,#0c7f9e);

		 background: linear-gradient(1turn, #FF6666, #ffd543);
	}
	.withdrawbtn{
		// background: linear-gradient(270deg,#ffd543,#3b58a4);

		background: linear-gradient(1turn, #339999, #ffd543);
	}
	.big_tit {
		position: absolute;
		height: 25px;
		font-size: 16px;
		font-weight: 500;
		line-height: 25px;
		top: 12px;
		left: 50%;
		transform: translateX(-50%);
		color: #323232;
		font-weight: bold;
	}

	.sub_btn {
		background: linear-gradient(1turn, #3b58a4, #ffd543);
		height: 30px;
		font-size: 12px;
		color: #FFFFFF;
		text-align: center;
		width: 94px;
		border-radius: 5px;
	}

	.remove_btn {
		background: linear-gradient(117deg, rgba(254, 166, 0, 1) 0%, rgba(255, 188, 0, 1) 100%);
		height: 36px;
		line-height: 36px;
		font-size: 12px;
		color: #FFFFFF;
		text-align: center;
		width: 94px;
		border-radius: 18px;
	}

	.home_tit {
		width: 100%;
		height: 22px;
		line-height: 22px;
		display: flex;
		align-items: center;
		justify-content: center;

		.line {
			width: 75px;
			height: 2px;
		}

		h5 {
			font-size: 16px;
			line-height: 22px;
			color: #000000;
			margin: 0 10px;
			font-weight: bold;
		}
	}

	.van-popup {
		max-width: 100%;
		margin: 0 auto;
		right: 0;
	}

	.back_left {
		width: 20px;
		height: 20px;
		background: url(./views/images/item/back.png) no-repeat center center;
		background-size: auto 100%;
		margin:0;
	}
	.getcode,.btn {
		background: #3fd7b2 ;
		color: #282828 ;
	}
	.basic_btn {
		width: 100%;
		border-radius: 5px;
		text-align: center;
		background: #3fd7b2!important;
		color: #fff;
		height: 38px;
		line-height: 38px;
		font-size: 16px;
	}

	.basic_btn.no_touch {
		color: rgba(255, 255, 255, 0.5);
	}
	.basic_wrap .form{
		border-color: #D0B8A8;
		background-image: linear-gradient(to right bottom, rgb(37, 75, 98) 0%, rgb(29, 62, 83) 100%);
	}
	.flex_center {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.wrap_box {
		// width: 100%;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
	}

	.eye_bi {
		width: 21px;
		height: 25px;
		background: url(./views/images/user/eye2.png) no-repeat center center;
		background-size: 100% auto;

		&.eye {
			background: url(./views/images/user/eye1.png) no-repeat center center;
			background-size: 100% auto;
		}
	}

	.real_name_mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 30;
		background-color: rgba(0, 0, 0, 0.95);

		.real_box {
			width: 272px;
			height: 185px;
			background: rgba(255, 255, 255, 1);
			border-radius: 8px;
			position: absolute;
			top: 50%;
			left: 0;
			right: 0;
			margin: -92px auto 0 auto;

			.tit {
				width: 77px;
				height: 67px;
				position: absolute;
				top: -35px;
				left: 50%;
				transform: translateX(-50%);
				background: url(./views/images/user/tit.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.tips {
				width: 185px;
				height: 50px;
				text-align: center;
				font-size: 18px;
				color: #000000;
				line-height: 25px;
				position: absolute;
				top: 49px;
				left: 50%;
				transform: translateX(-50%);
			}

			.basic_btn {
				width: 225px;
				position: absolute;
				left: 0;
				right: 0;
				margin: 0 auto;
				bottom: 15px;
			}
		}
	}

	.contract_box img {
		width: 100%;
	}
	.kefu_img{
		border-radius: 80px;
	}
	.logo{
		width: 30vw;
		height: 30vw;
		margin-left: auto;
		margin-right: auto;
		.logoimg{
			height: 100%;
			width: 100%;
		}
	}
	.logourl{
		font-size: 26px;
		line-height: 15vw;
		color: #FFF;
		text-align: center;
	}
	.item input{
		color: #FFFFFd;
	}
	.head-tabs {
	    height: 50px;
	    padding: 15px;
	    background: #3fd7b2;
	    white-space: nowrap;
		border-radius: 2.66667vw;
		text-align: center;
		width: 95%;
		margin: 10px auto;
		color: #fff;
		.tab-item {
		    z-index: 0;
		    position: relative;
		    height: 16px;
		    line-height: 16px;
		    font-size: 14px;
		    color: #fffffd;
		    transition: all .3s ease;
		}
		.tab-item:after {
		    z-index: -1;
		    content: "";
		    position: absolute;
		    left: 0;
		    right: 0;
		    bottom: 0;
		    height: 4px;
		    border-radius: 2px;

		}
		.active {
		    font-size: 16px;
		    color: #fffffd;
			:after {
			    background: #ff8c46;
			}
		}
		.tab-item.active:after {
		    background: #ff8c46;
		}
		.tab-item+.tab-item {
		    margin-left: 20px;
		}
	}


	h3.box-title{
		margin: 4vw 0 5.33333vw 6.93333vw;
		font-size: 4.26667vw;
		font-weight: 400;
		color: #3fd7b2;
	}
	h2.page-title{
		font-size: 25px;
		font-weight: 700;
		color: #3fd7b2;
		padding: 2vh 21px;
	}
	h3.page-title{
		color: #727d91;
		font-weight: 400;
		padding: 2vh 21px;
		padding-top: 0;
	}
	.ismid{
		.itimg{
			position: relative;
			z-index: 1;
			margin: -2em auto 0;
			width: 5em;
			height: 5em;
			border-top: 1px solid #191d22;
			border-radius: 100%;
			background: #fff;
			.icon{
				width: 1.6em;
				height: 1.6em;
				padding-top: 0.3em;
			}
		}

	}
	.bgdeep {
		color: #fff;
		background: linear-gradient(90deg,#52e8bb,#29c3a8) !important;
	}
	.bglight {
		background: #fff;
		color: #323232;
	}
	.gun{
		background:linear-gradient(90deg,#52e8bb,#29c3a8)  !important;
	}

</style>
